import { skipToken } from '@reduxjs/toolkit/query';

import { useCurrentUser } from '@/features/users/hooks';

import { useGetOpportunityOffersQuery } from '../api';
import { OpportunityDetails, OpportunityItemList } from '../types';

export function useIsOpportunityEnabled(opportunity: OpportunityItemList | OpportunityDetails | null) {
  const user = useCurrentUser();
  const { data: offers } = useGetOpportunityOffersQuery(opportunity ? { id: opportunity.id } : skipToken);

  if (!opportunity || !user || !offers) return null;

  const isUserCompany = opportunity.company === user.company.id;
  const userHasOffered = offers.offers.some((offer) => offer.company.id === user.company.id);
  const isOpen = opportunity.status.name !== 'closed';

  return isOpen || isUserCompany || userHasOffered;
}
